<template>
  <div class="cate-menu-box">
    <h2
      v-if="showTitle"
      class="cate-title"
    >
      <slot name="cate-title">
        ...
      </slot>
    </h2>
    <div class="cate-pic-cover">
      <img :src="coverPic">
    </div>
    <div class="cate-menu-description">
      <slot name="cate-description">
        ...
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CateMenu',
  props: {
    showTitle: {
      type: Boolean,
      default() {
        return true
      }
    },
    list: {
      type: Object,
      default() {
        return {}
      }
    },
    cateKey: {
      type: [String, Number],
      required: true
    },
    toRouteName: {
      type: [String],
      required: true
    },
    coverPic: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped lang="less">
    .cate-menu-box{
        &:hover{
            box-shadow:0 0 19px 1px rgba(66,66,66,0.1);
        }
        // height: 420px;
        background-color: #ffffff;
        position: relative;
        // width: 370px;
        margin: 20px 20px;
        padding: 0;
        .cate-title{
            font-size:22px;
            font-weight:500;
            color:rgba(132,132,132,1);
            text-align: center;
            margin: 20px 0;
            text-overflow:ellipsis; //溢出用省略号显示
            white-space:nowrap; //溢出不换行
            overflow:hidden; //超出的文本隐藏
        }
        * {
            max-width: 100%;
        }
        .cate-pic-cover{
            overflow: hidden;
        }
      .cate-menu-description {
        font-size:14px;
        font-weight:400;
        color:rgba(132,132,132,1);
        padding: 10px;
      }
    }
</style>
